import React, { useMemo, useState } from 'react';
import { PageHeading } from '../../../../../../SharedComponents';
import OverviewTable from './OverviewTable';
import { UserOneIcon } from '../../../../../../assets/icons';
import { ButtonBase } from '@material-ui/core';

function StaleLeadsTable({ data }) {
  const [viewAll, setViewAll] = useState(false);
  const displayedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return viewAll ? data : data.slice(0, 5);
  }, [data, viewAll]);
  return (
    <>
      <div className='leadxchange-table-header'>
        <PageHeading
          headerTitle={'Stale leads (+ 7 days) '}
          headerTitleClasses={'card-title'}
          wrapperClasses={'mb-0'}
        />
        {data?.length > 5 && (
          <ButtonBase onClick={() => setViewAll(!viewAll)}>
            <div className='view-all-text'>
              {viewAll ? 'Show Less' : 'View All'}
            </div>
          </ButtonBase>
        )}
      </div>
      <div className='leadxchange-divider' />
      <OverviewTable
        columns={[
          { key: 'lastActionDate', label: 'Action Date' },
          { key: 'crmLeadId', label: 'Lead ID' },
          { key: 'leadName', label: 'lead Name' },
        ]}
        data={displayedData}
        wrapperClass={'recent-lead-table'}
        renderCell={(key, value) => {
          if (key === 'leadName') {
            return (
              <div className='agent-cell'>
                <div className='agent-cell__icon'>
                  <UserOneIcon
                    width='24'
                    height='24'
                    fill={'#667085'}
                    style={{ flexShrink: '0' }}
                  />
                </div>
                <span className='agent-cell__name'>{value}</span>
              </div>
            );
          }
          return value;
        }}
      />
    </>
  );
}

export default StaleLeadsTable;
